import { render, staticRenderFns } from "./birthday_birthday_list.vue?vue&type=template&id=70a20f9a"
import script from "./birthday_birthday_list.vue?vue&type=script&lang=js"
export * from "./birthday_birthday_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports